/* BlackBole 2026 site script: header, drawer, footer sign-up, line drawings, product page. */
(function () {
  var $ = function (id) { return document.getElementById(id); };
  var $$ = function (sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* toast */
  var toast = $('bbToast');
  function say(html, ms) {
    if (!toast) return;
    toast.innerHTML = html; toast.classList.add('on');
    clearTimeout(say.t); say.t = setTimeout(function () { toast.classList.remove('on'); }, ms || 2600);
  }
  window.bbSay = say;

  /* top bar: rotate messages */
  var tb = $('bbTopbar');
  if (tb) {
    var msgs = (tb.getAttribute('data-msgs') || '').split(/\n+/).map(function (s) { return s.trim(); }).filter(Boolean);
    if (msgs.length > 1 && !reduce) {
      var k = 0;
      setInterval(function () { k = (k + 1) % msgs.length; var s = document.createElement('span'); s.textContent = msgs[k]; tb.replaceChildren(s); }, 4200);
    }
  }

  /* drawer */
  var dr = $('bbDrawer'), burger = $('bbBurger');
  function setDrawer(on) {
    if (!dr) return;
    dr.classList.toggle('on', on); dr.setAttribute('aria-hidden', !on);
    if (burger) burger.setAttribute('aria-expanded', on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
    if (on) { var i = dr.querySelector('input[type=search]'); if (i && matchMedia('(hover:hover)').matches) i.focus(); }
  }
  if (burger) burger.addEventListener('click', function () { setDrawer(true); });
  if (dr) $$('[data-close]', dr).forEach(function (x) { x.addEventListener('click', function () { setDrawer(false); }); });
  addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* footer sign-up: Shopify comes back with ?customer_posted=true */
  if (/customer_posted=true/.test(location.search) && $('bbfOk')) { $('bbfOk').hidden = false; }

  /* bag count */
  function setCount(n) {
    var a = $('bagLink'); if (!a) return;
    a.innerHTML = 'Bag' + (n > 0 ? ' (<span class="count">' + n + '</span>)' : '');
  }
  window.bbSetCount = setCount;

  /* line drawings draw themselves when scrolled into view */
  var svgs = $$('svg.draw');
  if (svgs.length && 'IntersectionObserver' in window && !reduce) {
    svgs.forEach(function (svg) {
      $$('.d', svg).forEach(function (el) {
        if (el.classList.contains('s')) { el.style.opacity = 0; el.style.transition = 'opacity .6s ease'; return; }
        var L = el.getTotalLength ? el.getTotalLength() : 0; if (!L) return;
        el.style.strokeDasharray = L; el.style.strokeDashoffset = L; el._L = L;
      });
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; io.unobserve(e.target);
        var els = $$('.d', e.target), k = 0;
        els.forEach(function (el) { if (el._L) { el.style.transition = 'stroke-dashoffset 1.6s cubic-bezier(.22,.61,.36,1) ' + (k * 0.18) + 's'; k++; requestAnimationFrame(function () { el.style.strokeDashoffset = 0; }); } });
        setTimeout(function () { els.forEach(function (el) { if (el.classList.contains('s')) el.style.opacity = ''; }); }, k * 180 + 900);
      });
    }, { threshold: 0.35 });
    svgs.forEach(function (s) { io.observe(s); });
  }

  /* anatomy pins */
  $$('.anat').forEach(function (an) {
    var pins = $$('.pin', an), parts = $$('.parts li', an);
    function pick(i) { pins.forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-p') == i); }); parts.forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-p') == i); }); }
    pins.concat(parts).forEach(function (el) { el.addEventListener('mouseenter', function () { pick(el.getAttribute('data-p')); }); el.addEventListener('click', function () { pick(el.getAttribute('data-p')); }); });
  });

  /* product cards (every page): photo arrows + save star */
  var WK = 'bbWish';
  function wishList() { try { return JSON.parse(localStorage.getItem(WK) || '[]'); } catch (e) { return []; } }
  function paintWish() { var l = wishList(); $$('[data-wish]').forEach(function (b) { var on = l.indexOf(b.getAttribute('data-wish')) > -1; b.setAttribute('aria-pressed', on); b.textContent = on ? '★' : '☆'; }); }
  window.bbPaintWish = paintWish;
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-wish]');
    if (w && !w.id) { e.preventDefault(); var h = w.getAttribute('data-wish'), l = wishList().filter(function (x) { return x !== h; }), on = w.getAttribute('aria-pressed') !== 'true'; if (on) l.push(h); try { localStorage.setItem(WK, JSON.stringify(l)); } catch (er) {} paintWish(); say(on ? 'Saved to your wishlist' : 'Removed from wishlist'); return; }
    var a = e.target.closest('.pc-arw');
    if (a) {
      e.preventDefault(); var ph = a.closest('.pc-ph'), list = (ph.getAttribute('data-imgs') || '').split('|').filter(Boolean); if (!list.length) return;
      var i = ((+ph.getAttribute('data-i') || 0) + (+a.getAttribute('data-step')) + list.length) % list.length; ph.setAttribute('data-i', i);
      var img = ph.querySelector('img'); if (!img) return; var u = list[i];
      img.style.opacity = 0; setTimeout(function () { img.srcset = [360, 540, 720, 900].map(function (wd) { return u.replace(/width=\d+/, 'width=' + wd) + ' ' + wd + 'w'; }).join(', '); img.src = u; img.style.opacity = ''; }, 150);
    }
  });
  paintWish();
  var SW = [['black','#1f1d1b'],['white','#f2eee6'],['cream','#f2eee6'],['ivory','#f2eee6'],['navy','#26324c'],['blue','#3f5f86'],['olive','#5c6239'],['green','#4d6a4b'],['sage','#4d6a4b'],['khaki','#9a8e62'],['mocha','#6a4a3b'],['tan','#b07a4a'],['camel','#b07a4a'],['brown','#6d4a31'],['chocolate','#6d4a31'],['coffee','#6d4a31'],['grey','#8d8b88'],['gray','#8d8b88'],['beige','#d6c5a6'],['sand','#d6c5a6'],['burgundy','#6b2534'],['maroon','#6b2534'],['wine','#6b2534'],['red','#a5352f'],['pink','#d9a3a8'],['yellow','#d1a83c'],['mustard','#d1a83c']];
  function swatch(t) { t = ' ' + String(t || '').toLowerCase().replace(/[^a-z]+/g, ' ') + ' '; for (var i = 0; i < SW.length; i++) if (t.indexOf(' ' + SW[i][0] + ' ') > -1) return SW[i][1]; return ''; }
  // no colour in the name, option or tags? read the shoe's main colour from its photo
  function autoDots(root) {
    $$('[data-auto]', root).forEach(function (el) {
      var u = el.getAttribute('data-auto'); el.removeAttribute('data-auto'); if (!u) return;
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var c = document.createElement('canvas'), n = 40; c.width = n; c.height = n; var g = c.getContext('2d'); g.drawImage(im, 0, 0, n, n);
          var d = g.getImageData(0, 0, n, n).data, r = 0, gg = 0, b = 0, k = 0, br = 0, bg = 0, bb = 0;
          // background = average of the four corners; skip anything close to it, keep the shoe
          [0, n - 1, n * (n - 1), n * n - 1].forEach(function (q) { br += d[q * 4] / 4; bg += d[q * 4 + 1] / 4; bb += d[q * 4 + 2] / 4; });
          for (var i = 0; i < d.length; i += 4) { var R = d[i], G = d[i + 1], B = d[i + 2], mx = Math.max(R, G, B), mn = Math.min(R, G, B); if (mx > 225 && mx - mn < 22) continue; if (Math.abs(R - br) + Math.abs(G - bg) + Math.abs(B - bb) < 60) continue; r += R; gg += G; b += B; k++; }
          if (k) el.style.background = 'rgb(' + Math.round(r / k) + ',' + Math.round(gg / k) + ',' + Math.round(b / k) + ')';
        } catch (e) {}
      };
      im.src = u.indexOf('//') === 0 ? 'https:' + u : u;
    });
  }
  window.bbAutoDots = autoDots;
  autoDots(document);
  // the same card, built in code (recommendations, recently viewed)
  var BRANDS = 'nike,adidas,asics,skechers,converse,timberland,puma,reebok,new balance,vans,crocs,fila,crevit,jordan,hoka,salomon,under armour,clarks,ecco,decathlon,stride rite,zara,shein,curren'.split(',');
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  window.bbCard = function (p, fmt) {
    var tags = (typeof p.tags === 'string' ? p.tags.split(',') : (p.tags || [])).map(function (t) { return String(t).trim(); });
    var pre = tags.indexOf('pre-order') > -1;
    var tl = (p.title || '').toLowerCase(), own = !pre && tags.indexOf('other-brand') < 0 && !BRANDS.some(function (b) { return tl.indexOf(b) > -1; });
    var parts = (p.title || '').split(' - '), name = parts[0], col = parts.length > 1 ? parts[parts.length - 1] : '';
    if (own && !/^blackbole/i.test(name)) name = 'BlackBole ' + name.replace(/ [–-] BlackBole Edition$/i, '');
    var badge = pre && p.available !== false ? '' : p.available === false ? 'Sold out' : tags.indexOf('bb-new') > -1 ? 'New arrival' : tags.indexOf('bb-bestseller') > -1 ? 'Bestseller' : '';
    var imgs = (p.media || []).filter(function (m) { return m.media_type === 'image'; }).map(function (m) { return m.src; });
    if (!imgs.length) imgs = (p.images || []).map(function (x) { return typeof x === 'string' ? x : x.src; });
    imgs = imgs.filter(Boolean).slice(0, 6).map(function (u) { u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=900'; });
    var nsize = 0; (p.options || []).forEach(function (o) { if (o && /size/i.test(o.name || '')) nsize = (o.values || []).length; });
    var url = p.url || ('/products/' + p.handle), price = p.price_min != null ? p.price_min : p.price, cmp = p.compare_at_price_min != null ? p.compare_at_price_min : p.compare_at_price;
    var src = imgs[0] ? imgs[0].replace(/width=\d+/, 'width=720') : '';
    var opt = (p.options || []).filter(function (o) { return o && /colou?r/i.test(o.name || ''); })[0];
    var hx = swatch(col) || (opt && swatch((opt.values || [])[0])) || swatch(tags.join(' ')) || swatch(p.title);
    var dot = hx ? '<i class="on" style="background:' + hx + '"></i>' : (imgs[0] ? '<i class="on" data-auto="' + esc(imgs[0].replace(/width=\d+/, 'width=48')) + '"></i>' : '');
    // several colours in one product: a dot for each
    var cvals = opt && opt.values && opt.values.length > 1 ? opt.values.slice(0, 5) : null;
    if (cvals) dot = cvals.map(function (val, i) { var x = swatch(val), st = x ? ' style="background:' + x + '"' : ''; return i === 0 ? '<i class="on"' + st + ' title="' + esc(val) + '"></i>' : '<a href="' + esc(url) + '"' + st + ' title="' + esc(val) + '" aria-label="' + esc(val) + '"></a>'; }).join('');
    var d = document.createElement('div'); d.className = 'pc' + (p.available === false ? ' out' : '') + (pre ? ' sq' : '');
    d.innerHTML = '<div class="pc-ph"' + (imgs.length > 1 ? ' data-imgs="' + esc(imgs.join('|')) + '"' : '') + '><a href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + (src ? '<img class="a" loading="lazy" alt="" src="' + esc(src) + '">' : '') + '</a>' + (imgs.length > 1 ? '<button type="button" class="pc-arw l" data-step="-1" aria-label="Previous photo">‹</button><button type="button" class="pc-arw r" data-step="1" aria-label="Next photo">›</button>' : '') + '</div>' +
      '<div class="pc-meta"><small class="pc-made">' + (pre ? 'Pre-order · arrives in ' + (tags.indexOf('pre-order-delivery-advance') > -1 ? '12–13' : '15–20') + ' days' : own && !/sneaker|hiking/i.test((p.type || '') + ' ' + (p.title || '')) ? 'Made in Bangladesh' : 'Made in China') + '</small><a class="pc-name" href="' + esc(url) + '">' + esc(name) + '</a>' +
      '<p class="pc-price">' + (pre ? fmt(cmp > price ? cmp : price * 2) : fmt(price) + (cmp > price ? '<s>' + fmt(cmp) + '</s>' : '')) + '</p><div class="pc-row"><span class="pc-sw">' + dot + '</span>' + (nsize > 1 ? '<span class="pc-note">' + nsize + ' sizes</span>' : '') + '</div>' +
      '<p class="pc-acc">' + (pre ? (tags.indexOf('pre-order-delivery-advance') > -1 ? 'Book with just the ' + fmt(9000) + ' delivery charge' : 'Book with ' + fmt(price)) : tags.indexOf('bb-leather') > -1 ? 'Genuine leather' : '') + '</p><div class="pc-foot">' + (badge ? '<span class="pc-bdg">' + badge + '</span>' : '') + '<button class="pc-wish" type="button" data-wish="' + esc(p.handle) + '" aria-label="Save ' + esc(name) + '" aria-pressed="false">☆</button></div></div>';
    return d;
  };

  /* ---------------- product page ---------------- */
  var pd = $('bbPdp'); if (!pd) return;
  var data = JSON.parse($('bbPdpData').textContent);
  var imgs = data.images, cur = 0, money = data.money;
  var mainImg = $('mainImg'), rail = $$('#rail button'), dots = $$('#dots i');

  function show(i) {
    if (!imgs.length) return;
    cur = (i + imgs.length) % imgs.length;
    mainImg.style.opacity = 0;
    setTimeout(function () { var u = imgs[cur].big; if (/width=\d+/.test(u)) { mainImg.srcset = [600, 900, 1200, 1400].map(function (w) { return u.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', '); } else mainImg.removeAttribute('srcset'); mainImg.src = u; mainImg.alt = imgs[cur].alt; mainImg.style.opacity = 1; }, 160);
    rail.forEach(function (b, k) { b.setAttribute('aria-current', k === cur); });
    dots.forEach(function (d, k) { d.classList.toggle('on', k === cur); });
    if ($('cnt')) $('cnt').textContent = (cur + 1) + ' / ' + imgs.length;
    var rb = rail[cur]; if (rb && rb.parentNode.scrollHeight > rb.parentNode.clientHeight) rb.scrollIntoView({ block: 'nearest' });
  }
  // jump the gallery to a given photo (matched by file name)
  function fileOf(u) { return String(u || '').split('?')[0].split('/').pop(); }
  function showImg(u) { var f = fileOf(u); for (var i = 0; i < imgs.length; i++) if (fileOf(imgs[i].big) === f) { show(i); return; } }
  rail.forEach(function (b) { b.addEventListener('click', function () { show(+b.getAttribute('data-i')); }); });
  if ($('nextImg')) $('nextImg').addEventListener('click', function () { show(cur + 1); });
  var stage = $('stage'), sx = null;
  stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null; });
  stage.addEventListener('click', function (e) {
    if (matchMedia('(hover:none)').matches) return;
    var on = !stage.classList.contains('zoom'); stage.classList.toggle('zoom', on);
    if (on) { var r = stage.getBoundingClientRect(); mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; }
  });
  stage.addEventListener('mousemove', function (e) { if (!stage.classList.contains('zoom')) return; var r = stage.getBoundingClientRect(); mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; });

  /* thumb rail: up to four thumbs end exactly where the main photo ends; more scroll */
  function fitRail() {
    var r = $('rail'); if (!r || getComputedStyle(r).display === 'none') return;
    var n = Math.min(Math.max(rail.length, 1), 4);
    pd.style.removeProperty('--rw');
    var A = stage.offsetWidth + r.offsetWidth, gap = 10;
    var rw = Math.max(56, Math.round((A - 8 * (n - 1)) / (n + 1)));
    pd.style.setProperty('--rw', rw + 'px');
    requestAnimationFrame(function () { pd.style.setProperty('--rh', stage.offsetHeight + 'px'); });
  }
  fitRail(); addEventListener('resize', fitRail); addEventListener('load', fitRail);

  /* variants */
  var opts = data.options, variants = data.variants, sizeIx = data.sizeIndex;
  var sel = opts.map(function (o, i) { return i === sizeIx ? null : (data.initial ? data.initial[i] : o.values[0]); });
  function match(vals) { return variants.filter(function (v) { return vals.every(function (x, i) { return x === null || v.options[i] === x; }); }); }
  function current() { if (sel.some(function (x) { return x === null; })) return null; return match(sel)[0] || null; }
  var row = $('szrow'), stock = $('stock'), add = $('add'), barAdd = $('barAdd');
  // show the full shoe size range, even sizes this style isn't made in (crossed out)
  var sizeList = [];
  if (sizeIx >= 0) {
    var have = opts[sizeIx].values.slice();
    var nums = have.every(function (x) { return /^\d+(\.5)?$/.test(String(x).trim()); });
    if (nums) {
      var lo = Math.min.apply(null, have.map(Number)), base = lo <= 37 ? [35,36,37,38,39,40,41] : [39,40,41,42,43,44,45];
      var all = base.map(String); have.forEach(function (x) { if (all.indexOf(String(x)) < 0) all.push(String(x)); });
      sizeList = all.sort(function (a, b) { return a - b; });
    } else sizeList = have;
    // only one size available? pick it so the shopper can add straight away
    var t0 = sel.slice(), av0 = have.filter(function (val) { t0[sizeIx] = val; var m = match(t0)[0]; return m && m.available; });
    if (av0.length === 1) sel[sizeIx] = av0[0];
  }

  function render(msg) {
    // other options as pills
    $$('[data-opt]').forEach(function (box) {
      var oi = +box.getAttribute('data-opt'); box.innerHTML = '';
      opts[oi].values.forEach(function (val) {
        var b = document.createElement('button'); b.type = 'button';
        var test = sel.slice(); test[oi] = val; test[sizeIx] = null;
        var any = match(test).some(function (v) { return v.available; });
        // colour options: a small photo of that colour, taken from its variant
        var vi = /colou?r/i.test(opts[oi].name) ? match(test).filter(function (v) { return v.img; })[0] : null;
        if (vi) { b.className = 'sw' + (any ? '' : ' out'); b.setAttribute('aria-label', val); b.innerHTML = '<img src="' + vi.img + '" alt="" loading="lazy"><span></span>'; b.querySelector('span').textContent = val; }
        else { b.textContent = val; if (!any) b.className = 'out'; }
        b.setAttribute('aria-pressed', sel[oi] === val);
        b.addEventListener('click', function () { sel[oi] = val; var lb = $('optName' + oi); if (lb) lb.textContent = val; if (sizeIx >= 0 && sel[sizeIx] !== null) { var t = sel.slice(); if (!match(t)[0] || !match(t)[0].available) sel[sizeIx] = null; } render(); if (vi) showImg(vi.img); });
        box.appendChild(b);
      });
    });
    // sizes
    if (row && sizeIx >= 0) {
      row.innerHTML = '';
      sizeList.forEach(function (val) {
        var t = sel.slice(); t[sizeIx] = val; var v = match(t)[0];
        var ok = v && v.available;
        var b = document.createElement('button'); b.type = 'button'; b.className = 'sz' + (ok ? '' : ' out'); b.textContent = val;
        b.setAttribute('aria-pressed', sel[sizeIx] === val); b.setAttribute('aria-label', 'Size ' + val + (ok ? '' : (v ? ', sold out' : ', not available')));
        b.addEventListener('click', function () {
          if (!ok) { sel[sizeIx] = null; render('<b>EU ' + val + '</b> is ' + (v ? 'sold out right now.' : 'not available in this style.')); return; }
          sel[sizeIx] = val; render();
        });
        row.appendChild(b);
      });
    }
    var v = current();
    if (stock) {
      if (msg) stock.innerHTML = msg;
      else if (v) stock.innerHTML = '<b>' + (sizeIx >= 0 ? 'EU ' + sel[sizeIx] : v.title) + '</b> · ' + left(v);
      else if (sizeIx >= 0) {
        var t = sel.slice(); var avail = opts[sizeIx].values.filter(function (val) { t[sizeIx] = val; var m = match(t)[0]; return m && m.available; });
        stock.innerHTML = avail.length === sizeList.length ? 'All sizes in stock.' : (avail.length ? 'Available in EU ' + avail.join(', ') + '.' : 'Sold out in every size right now.');
      } else stock.innerHTML = '';
    }
    // pre-order: the button also says how much is paid now
    var price = v ? v.price : data.price, cmp = v ? v.compare : data.compare;
    // pre-order: the Shopify price is the booking money; the full price is the compare-at price (older items: twice the price)
    var full = cmp > price ? cmp : price * 2, book = data.booking || price;
    var base = data.pre ? 'Pre-order' : 'Add to bag', half = data.pre ? ' · Book with ' + fmt2(book) : '';
    var label = v ? (v.available ? base + (sizeIx >= 0 ? ' · EU ' + sel[sizeIx] : '') + half : 'Sold out') : base + half;
    if (add) add.textContent = label; if (barAdd) barAdd.textContent = label;
    if (data.pre) {
      if ($('pPrice')) $('pPrice').textContent = fmt2(full);
      if ($('preNow')) $('preNow').textContent = fmt2(book);
      if ($('preDue')) $('preDue').textContent = fmt2(data.fee ? full : full - book);
      if ($('barSub')) $('barSub').textContent = fmt2(full) + (v && sizeIx >= 0 ? ' · EU ' + sel[sizeIx] : '');
    } else {
    if ($('pPrice')) $('pPrice').innerHTML = fmt(price) + (cmp > price ? '<s>' + fmt(cmp) + '</s>' : '');
    if ($('barSub')) $('barSub').textContent = fmt(price) + (v && sizeIx >= 0 ? ' · EU ' + sel[sizeIx] : '');
    }
    var pw = $('payw'); if (pw && $('advAmt')) { var pct = +pw.getAttribute('data-pct') || 5; $('advAmt').textContent = fmt(Math.floor(price * (100 - pct) / 100)); pw.style.display = (v && !v.available) ? 'none' : ''; }
    // keep the chosen size where the COD app looks for it (product form + ?variant= in the address)
    if (v && $('bbEsId')) { $('bbEsId').value = v.id; try { var u = new URL(location.href); if (u.searchParams.get('variant') !== String(v.id)) { u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } } catch (e) {} }
  }
  // how many are left of the chosen variant (only when Shopify tracks the stock)
  function left(v) {
    if (!v.available) return 'Sold out';
    if (!v.tracked || v.qty <= 0) return 'In stock';
    var unit = sizeIx >= 0 ? (v.qty === 1 ? ' pair' : ' pairs') : '';
    return (v.qty <= 3 ? '<span class="low">Only ' + v.qty + unit + ' left</span>' : v.qty + unit + ' left');
  }
  function fmt(c) { return money.replace(/\{\{\s*\w+\s*\}\}/, Math.round(c / 100).toLocaleString('en-IN')); }
  function fmt2(c) { return money.replace(/\{\{\s*\w+\s*\}\}/, (Math.round(c) / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })); }
  if (opts.length === 1 && opts[0].values.length === 1 && sizeIx < 0) sel = [opts[0].values[0]];
  render();

  /* fit finder + chart */
  var BASE = data.chart;
  if ($('fitTgl')) $('fitTgl').addEventListener('click', function () { var f = $('fit'); f.hidden = !f.hidden; if (!f.hidden) $('foot').focus(); });
  if ($('foot')) $('foot').addEventListener('input', function () {
    var v = parseFloat(this.value), a = $('fitAns'); if (!v) { a.textContent = ''; return; }
    var best = BASE.reduce(function (p, s) { return Math.abs(s.cm - v) < Math.abs(p.cm - v) ? s : p; }); var i = BASE.indexOf(best);
    if (v > best.cm + 0.3 && i < BASE.length - 1) best = BASE[i + 1];
    var t = sel.slice(); t[sizeIx] = String(best.eu); var m = match(t)[0];
    if (!m) { a.innerHTML = 'You are <b>EU ' + best.eu + '</b>. This pair does not come in that size.'; return; }
    a.innerHTML = 'You are <b>EU ' + best.eu + '</b>' + (m.available ? '. Selected.' : '. Sold out right now.');
    if (m.available) { sel[sizeIx] = String(best.eu); render(); }
  });
  var modal = $('chartModal');
  function openChart() {
    var ch = $('chart'); ch.innerHTML = '';
    BASE.forEach(function (s) { var tr = document.createElement('tr'); if (sizeIx >= 0 && sel[sizeIx] == s.eu) tr.className = 'me'; tr.innerHTML = '<td>' + s.eu + '</td><td>' + s.uk + '</td><td>' + s.us + '</td><td>' + s.cm.toFixed(1) + ' cm</td>'; ch.appendChild(tr); });
    modal.hidden = false; document.documentElement.style.overflow = 'hidden';
  }
  function closeChart() { modal.hidden = true; document.documentElement.style.overflow = ''; }
  if ($('chartTgl') && modal) { $('chartTgl').addEventListener('click', openChart); $$('[data-close]', modal).forEach(function (x) { x.addEventListener('click', closeChart); }); addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeChart(); }); }

  /* add to bag (Shopify cart API) */
  var payw = $('payw'), payCod = $('payCod'), payNow = $('payNow');
  function busy(on) { [add, barAdd, payCod, payNow].forEach(function (b) { if (b) b.disabled = on; }); }
  // go: undefined = stay here, 'cod' = bag with cash on delivery chosen, 'now' = checkout with the advance discount
  function addToBag(go) {
    var v = current();
    if (!v) { say('Choose a size first'); var s = $('sizes'); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    if (!v.available) { say('That size is sold out'); return; }
    busy(true);
    var item = { id: v.id, quantity: 1 };
    // pre-order: note the full price and what is due on delivery (shown in the bag, checkout and the order)
    if (data.pre) { item.properties = { 'Pre-order': 'Arrives in ' + data.preDays + ' days', 'Full price': fmt2(v.compare > v.price ? v.compare : v.price * 2), 'Booking paid': fmt2(data.booking || v.price), 'Due on delivery': fmt2((v.compare > v.price ? v.compare : v.price * 2) - (data.booking || v.price)) }; if (data.fee) { var fl = v.compare > v.price ? v.compare : v.price * 2; delete item.properties['Booking paid']; item.properties['Delivery charge paid'] = fmt2(data.booking); item.properties['Due on delivery'] = fmt2(fl); } go = 'pre'; }
    fetch(data.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (go === 'pre') { location.href = data.root + 'checkout'; return 'away'; }
        if (go === 'now') { try { localStorage.setItem('bbPay', 'now'); } catch (e) {} location.href = data.root + 'checkout?discount=' + encodeURIComponent(payw.getAttribute('data-code') || 'ADVANCE5'); return 'away'; }
        if (go === 'cod') { try { localStorage.setItem('bbPay', 'cod'); sessionStorage.setItem('bbAutoCod', '1'); } catch (e) {} location.href = data.root + 'cart'; return 'away'; }
        return fetch(data.root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart === 'away') return; setCount(cart.item_count); say('Added to your bag <a href="' + data.root + 'cart">View bag</a>', 4000); busy(false); })
      .catch(function (err) { busy(false); say((err && (err.description || err.message)) || 'Could not add to bag. Please try again.'); });
  }
  if (add) add.addEventListener('click', function () { addToBag(); });
  if (barAdd) barAdd.addEventListener('click', function () { addToBag(); });
  // Cash on delivery: the EasySell app opens its order form from this button (class es-popup-button-overwrite).
  // We only step in when no size is chosen, or if the app's form doesn't appear (then: bag page with COD ready).
  if (payCod) payCod.addEventListener('click', function (e) {
    var v = current();
    if (!v || !v.available) { e.preventDefault(); e.stopImmediatePropagation(); addToBag('cod'); return; }
    var seen = false, mo = new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        var list = m.type === 'attributes' ? [m.target] : [].slice.call(m.addedNodes);
        list.forEach(function (n) {
          if (seen || n.nodeType !== 1 || n === payCod || pd.contains(n)) return;
          if (/(^|[\s_-])es[-_]|easy-?sell/i.test((n.id || '') + ' ' + (typeof n.className === 'string' ? n.className : ''))) { seen = true; return; }
          var cs = getComputedStyle(n), r = n.getBoundingClientRect();
          if ((cs.position === 'fixed' || cs.position === 'absolute') && cs.display !== 'none' && cs.visibility !== 'hidden' && r.width > innerWidth * 0.4 && r.height > 150) seen = true;
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    setTimeout(function () { mo.disconnect(); if (!seen) addToBag('cod'); }, 1500);
  }, true);
  if (payNow) payNow.addEventListener('click', function () { addToBag('now'); });

  /* sticky bar once the main button scrolls away */
  var bar = $('bar');
  if (bar && add) { document.body.classList.add('bb-has-bar'); if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { bar.classList.toggle('on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(add); }

  /* wishlist (this device only) */
  var wish = $('wish');
  if (wish) {
    var key = 'bbWish', list = []; try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
    var on = list.indexOf(data.handle) > -1; wish.textContent = on ? '★' : '☆';
    wish.addEventListener('click', function () { on = !on; wish.textContent = on ? '★' : '☆'; list = list.filter(function (h) { return h !== data.handle; }); if (on) list.push(data.handle); try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {} say(on ? 'Saved to your wishlist' : 'Removed from wishlist'); });
  }

  /* you may also like: Shopify product recommendations */
  var cards = $('alsoCards');
  if (cards) {
    fetch(data.root + 'recommendations/products.json?product_id=' + data.id + '&limit=4')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        (j.products || []).slice(0, 4).forEach(function (p) { cards.appendChild(window.bbCard(p, fmt)); });
        paintWish(); autoDots(cards);
        if (!cards.children.length) { var sec = cards.closest('section'); if (sec) sec.hidden = true; }
      }).catch(function () { var sec = cards.closest('section'); if (sec) sec.hidden = true; });
  }
})();
